import { ConfigProvider } from 'antd';

import useColor from '@/hooks/domain/useColor';

type Props = {
  children: React.ReactNode;
};

const ChartTableConfigProvider = (props: Props) => {
  const color = useColor();
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            borderColor: color.gray300,
            headerBg: color.gray100,
            headerSortActiveBg: color.gray100,
            headerSortHoverBg: color.gray100,
            cellFontSize: 12,
          },
        },
      }}
    >
      {props.children}
    </ConfigProvider>
  );
};

export default ChartTableConfigProvider;
